import { useState, useEffect } from "react";
import { 
  getAllCountries, 
  getRegionsByCountry, 
  createDistrict 
} from "../Api/DistrictMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const DistrictMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);

  const [districtData, setDistrictData] = useState({
    code: "",
    description: "",
    country: "",
    region: ""
  });

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getAllCountries();
        setCountries(data);
      } catch (error) {
        toast.error("🦄 Failed to load countries!");
      }
    };
    fetchCountries();
  }, []);

  // Fetch regions when country changes
  useEffect(() => {
    const fetchRegions = async () => {
      if (districtData.country) {
        try {
          const data = await getRegionsByCountry(districtData.country);
          setRegions(data);
        } catch (error) {
          toast.error("🦄 Failed to load regions!");
        }
      } else {
        setRegions([]);
        setDistrictData(prev => ({ ...prev, region: "" }));
      }
    };
    fetchRegions();
  }, [districtData.country]);

  const handleChange = (e) => {
    setDistrictData({ ...districtData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createDistrict(districtData);
      toast.success("🦄 District Added Successfully");
      setDistrictData({
        code: "",
        description: "",
        country: "",
        region: ""
      });
      
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">District Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>District Code <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="code" 
                      value={districtData.code} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">**</span></Form.Label>
                    <Form.Control 
                      type="text" 
                      name="description" 
                      value={districtData.description} 
                      onChange={handleChange} 
                      required 
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country Code <span className="text-red">**</span></Form.Label>
                    <Form.Select 
                      name="country" 
                      value={districtData.country} 
                      onChange={handleChange} 
                      required
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.countryCode} value={country.countryCode}>
                          {country.countryCode} - {country.countryName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Region Code <span className="text-red">**</span></Form.Label>
                    <Form.Select 
                      name="region" 
                      value={districtData.region} 
                      onChange={handleChange} 
                      required
                      disabled={!districtData.country}
                    >
                      <option value="">Select Region</option>
                      {regions.map((region) => (
                        <option key={region.regionCode} value={region.regionCode}>
                          {region.regionCode} - {region.regionName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save District
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {/* Loader Overlay with Sample 14 */}
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default DistrictMaster;